export default __webpack_public_path__ + "static/media/bb1.3f47d7eb.png";